import { ModelBase, Property, ShortString } from '@skylab-shared/core';
import { BankAccountStatus } from './../bank-account/bank-account-status';


export class PurchaseBankAccountModel extends ModelBase {
    @Property()
    public bankName: string;

    @Property()
    @ShortString('data-model.purchase.validation.bank-account-number.length')
    public number: string;

    @Property()
    public status: BankAccountStatus;

    @Property(Date, { nullable: true })
    public statusDate: Date | null;

    @Property(String, { nullable: true })
    public statusId: string | null;

}
